type Props = {
    title: string;
    isOpen: boolean;
    setIsOpen: (open: boolean) => void;
    subtitle?: string;
};

const SectionHeader = ({ title, isOpen, setIsOpen, subtitle }: Props) => {
    return (
        <div className="border bg-blue overflow-hidden shadow">
            <button
                type="button"
                onClick={() => setIsOpen(!isOpen)}
                className="w-full text-white px-4 py-3 cursor-pointer select-none flex justify-between items-center hover:bg-blue focus:bg-blue 2xl:h-[42px] 2xl:py-0"
                aria-expanded={isOpen}
            >
                <div className="flex-1 flex justify-center items-center gap-2" role="heading" aria-level={2}>
                    <span className="text-[18px] font-bold uppercase">{title}</span>
                    {subtitle && <span className="text-[18px] font-bold text-white whitespace-nowrap">{subtitle}</span>}
                </div>
                <span className="text-xl ml-4">{isOpen ? "−" : "+"}</span>
            </button>
        </div>
    );
};

export default SectionHeader;
